import React from "react";
import { AnimatePresence } from "framer-motion";
import { Route, Routes, useLocation } from "react-router-dom";
import HomePage from "../pages/home";
import ScrollToTop from "../components/ScrollToTop";
import About from "../pages/about";
import Solution from "../pages/solution";
import Sss from "../pages/sss";
import Partner from "../pages/partner";
import Contact from "../pages/contact";
import ContractPage from "../pages/contract";
import WagesPage from "../pages/wages";
import DownloadPage from "../pages/download";
import CMS from "../pages/cms";
const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence>
      <ScrollToTop />
      <Routes key={location.pathname} location={location}>
        <Route path="/" element={<HomePage />} />
        <Route path="/anasayfa" element={<HomePage />} />
        <Route path="/homepage" element={<HomePage />} />
        <Route path="/hakkimizda" element={<About />} />
        <Route path="/about" element={<About />} />
        <Route path="/istasyonlar" element={<Solution />} />
        <Route path="/stations" element={<Solution />} />
        <Route path="/sss" element={<Sss />} />
        <Route path="/faq" element={<Sss />} />
        <Route path="/is-ortaklarimiz" element={<Partner />} />
        <Route path="/partner" element={<Partner />} />
        <Route path="/iletisim" element={<Contact />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/ucretler" element={<WagesPage />} />
        <Route path="/wages" element={<WagesPage />} />
        <Route path="/indirme" element={<DownloadPage />} />
        <Route path="/download" element={<DownloadPage />} />
        <Route path="/:slug" element={<CMS />} />

        <Route path="/uyelik-sozlesmesi" element={<ContractPage />} />
        <Route path="/membership-contract" element={<ContractPage />} />
        <Route path="/gizlilik-sozlesmesi" element={<ContractPage />} />
        <Route path="/privacy-policy" element={<ContractPage />} />
        <Route path="/satis-sozlesmesi" element={<ContractPage />} />
        <Route path="/mesafeli-satis-sozlesmesi" element={<ContractPage />} />
        <Route path="/distance-sales-agreement" element={<ContractPage />} />
        <Route path="/sales-contract" element={<ContractPage />} />
        <Route path="/iptal-ve-iade-kosullari" element={<ContractPage />} />
        <Route path="/cancellation-and-refund-conditions" element={<ContractPage />} />
        <Route path="/*" element={<HomePage />} />
      </Routes>
    </AnimatePresence>
  );
};

export default AnimatedRoutes;
